module.exports = __webpack_public_path__ + "media/digital/Digitization-Testimonial-16904f7d.png";